<template>
  <div class="route-viewer">
    <div class="columns">
      <div class="column is-one-fifth" style="padding : 0.25rem">
        <div class="box">
          <PodFilters :planningId="planningId" ></PodFilters>
        </div>
      </div>
      <div class="column" style="padding : 0.25rem">
        <div class="box">
          <RouteFilters></RouteFilters>
        </div>
      </div>
    </div>

    <div class="columns" style="height:calc(100% - 72px); margin: 0;">
      <div class="column is-one-fifth" style="height:100%; padding : 0.25rem">
        <div class="card" style="height:100%; overflow: auto;">
          <draggable v-model="pods" group="pod">
            <Pod
              :planningId="planningId"
              :siteCode="pod.site.code"
              :podId="pod.id"
              v-for="(pod, index) in pods"
              :key="index"
              :sort="false"
            ></Pod>
          </draggable>

          <div class="empty_pods" v-if="!pods || pods.length == 0">
            <b-icon icon="magnify" size="is-small"></b-icon>&nbsp;{{$t('RouteViewer.no_pods_found')}}
          </div>
          <div class="more_result" v-else-if="pods.length >= perPage">
            <b-icon icon="magnify" size="is-small"></b-icon>&nbsp;{{$t('RouteViewer.too_many_result')}}
          </div>
        </div>
      </div>
      <div class="column is-four-fifths" style="height:100%; max-width: 100%; padding : 0.25rem">
        <div class="card" style="height:100%; overflow: auto; max-width: 100%;">
          <div class="route-container">
            <Route
              :planningId="planningId"
              :route="route"
              v-for="(route, index) in routes"
              :key="index"
            ></Route>
            <div class="add-route">
              <div class="add-route-button">
                <button class="button is-primary is-small" @click="createRoute()">
                  {{$t('RouteViewer.action_add_route')}}&nbsp;&nbsp;&nbsp;
                  <b-icon icon="plus"/>
                </button>
              </div>
            </div>
            <div class="empty_routes" v-if="!routes || routes.length == 0">
              <div style="margin:auto;">
                <b-icon icon="magnify" size="is-small"></b-icon>{{$t('RouteViewer.no_route_found')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import draggable from 'vuedraggable'
import Route from './Route.vue'
import Pod from './Pod.vue'
import RouteFilters from './RouteFilters.vue'
import PodFilters from './PodFilters.vue'
import RouteModal from './RouteModal.vue'
import { perPage } from '../utils/constants'

export default {
  name: 'RouteViewer',
  components: {
    draggable,
    Route,
    Pod,
    RouteFilters,
    PodFilters
  },

  /* Initialisation of the component, loading data... */
  mounted () {
    // Data exist ? Have been already loaded ?
    if (this.$store.getters['planning/routes'](this.planningId).length === 0) {
      this.$log.info('Request routes of planning(id=' + this.planningId + ')...')
      this.$store.dispatch('planning/retrieveAllRoutesForPlanning', this.planningId)

      this.$log.info('Request pods of planning(id=' + this.planningId + ')...')
      this.$store.dispatch('planning/retrieveAllPods', this.planningId)
    }
  },

  props: {
    planningId: {
      type: Number
    }
  },

  data () {
    return {
      perPage
    }
  },

  computed: {
    pods: {
      get () {
        this.$log.info('Rendering pods of planning(id=' + this.planningId + ')...')
        return this.$store.getters['planning/pods'](this.planningId)
      },
      set (pods) {
        /** Group pod by site code and then merge it */
        var results = pods.reduce(function (results, pod) {
          if (results[pod.site.code]) {
            for (let i = 0; i < results[pod.site.code].days.length; i++) {
              results[pod.site.code].days[i] |= pod.days[i]
            }
          } else {
            results[pod.site.code] = pod
          }
          return results
        }, {})

        this.$store.commit('planning/updatePods', [this.planningId, Object.values(results)])
      }
    },
    routes: function () {
      this.$log.info('Rendering routes of planning(id=' + this.planningId + ')...')
      return this.$store.getters['planning/routes'](this.planningId)
    }
  },
  methods: {
    createRoute () {
      this.$buefy.modal.open({
        parent: this,
        component: RouteModal,
        props: {
          planningId: this.planningId,
          action: 'CREATE'
        }
      })
    }

  }
}
</script>

<style lang="scss">
.route-viewer {
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}

.box {
  border-radius: 0px !important;
  padding: 0.75rem;
  height: 100%;
}

.add-route {
  height: max-content;
  display: flex;
  min-height: 100%;
  min-width: 250px;
  border-width: 3px;
  border-color: #ac936c;
  border-style: dashed;
  background-color: white;
  margin: 0 5px 0 5px;
  justify-content: center;
}
.add-route-button {
  margin: auto;
}

/************************************ POD ************************************/
.pods-container-header {
  text-align: center;
  font-style: italic;
}

.pods-container {
  height: 100%;
}

.more_result {
  text-align: center;
}

.empty_pods {
  height: 100%;
  text-align: center;
}

.empty_routes {
  height: 100%;
  text-align: center;
  margin: auto;
}

/************************************ ROUTE ************************************/
.route-container {
  width: 100%;
  overflow: auto;
  display: inline-flex;
  padding: 5px;
  height: 100%;
  max-width: 100%;
}

/************************************ OTHER ************************************/
.list-group {
  height: 100%;
  width: 100%;
}

.route-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}

.route-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(68, 137, 147, 0.3);
  background-color: #70aab3;
}
</style>
